<script lang="ts">
  export let type: 'success' | 'error' = 'success';
  export let message: string | object = '';
  export let show: boolean = false;
  export let duration: number = 4000;
  export let onDismiss: (() => void) | undefined = undefined;

  let visible = false;
  let timeoutId: number | null = null;

  $: if (show && !visible) {
    visible = true;
    if (duration > 0) {
      timeoutId = setTimeout(() => {
        handleDismiss();
      }, duration);
    }
  }

  $: if (!show) {
    visible = false;
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
  }

  $: displayMessage = typeof message === 'string' 
    ? message 
    : (message as any)?.message || JSON.stringify(message);

  function handleDismiss() {
    visible = false;
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    show = false; // Update the bound show property
    if (onDismiss) {
      onDismiss();
    }
  }

  function dismiss() {
    handleDismiss();
  }
</script>

{#if visible}
  <div class="notification notification-{type}">
    <div class="notification-content">
      <div class="notification-icon">
        {#if type === 'success'}
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        {:else}
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        {/if}
      </div>
      <span class="notification-message">{displayMessage}</span>
      <button type="button" class="notification-close" on:click={dismiss} aria-label="Close notification">×</button>
    </div>
  </div>
{/if}

<style>
  .notification {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 990000;
    min-width: 300px;
    max-width: 500px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    animation: slideIn 0.3s ease-out;

  }

  .notification-content {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: white;
    border-radius: 8px;
    border-left: 4px solid;
  }

  .notification-success .notification-content {
    border-left-color: #10b981;
  }

  .notification-error .notification-content {
    border-left-color: #ef4444;
  }

  .notification-icon {
    flex-shrink: 0;
  }

  .notification-success .notification-icon {
    color: #10b981;
  }

  .notification-error .notification-icon {
    color: #ef4444;
  }

  .notification-message {
    flex: 1;
    font-size: 0.875rem;
    color: #374151;
    line-height: 1.4;
  }

  .notification-close {
    flex-shrink: 0;
    background: none;
    border: none;
    font-size: 1.25rem;
    color: #9ca3af;
    cursor: pointer;
    padding: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease;
  }

  .notification-close:hover {
    color: #6b7280;
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  @media (max-width: 640px) {
    .notification {
      left: 20px;
      right: 20px;
      min-width: unset;
      z-index: 1000;
    }
  }
</style>